import { getAccounts, Account } from '../modules/accountant/core/_request'

export const VAT_TYPE_EXCLUDED = 'excluded'
export const VAT_TYPE_INCLUDED = 'included'
export const VAT_TYPE_NONE = 'none'

export const EXPENSE_TYPE_DEPOSIT = 'deposit_payment'
export const EXPENSE_TYPE_PURCHASE = 'purchase_record'
export const EXPENSE_TYPE_PURCHASE_CREDIT_NOTE = 'purchase_credit_note'
export const EXPENSE_TYPE_PURCHASE_DEBIT_NOTE = 'purchase_debit_note'
export const EXPENSE_TYPE_ALL = 'all'

export const DEFAULT_VAT_TYPE = VAT_TYPE_EXCLUDED

export enum IncomeDocumentTypes {
  QUOTATION = 'quotation',
  DEPOSIT = 'deposit',
  INVOICE = 'invoice',
  RECEIPT = 'receipt',
  DEBIT = 'debit',
  CREDIT = 'credit',
  BILLING = 'billing',
  TAX_INVOICE = 'tax-invoice',
  EXPENSE_PURCHASE_ORDER = 'expense-purchase-order',
  EXPENSE_PURCHASE_ASSET_ORDER = 'expense-purchase-asset-order',
  EXPENSE_REQUEST_PURCHASE_ORDER = 'expense-request-purchase-order',
  EXPENSE_DEPOSIT_PAYMENT = 'expense-deposit-payment',
  EXPENSE_PURCHASE_INVENTORY_RECORD = 'expense-purchase-inventory-record',
  EXPENSE_EXPENSE_RECORD = 'expense-expense-record',
  EXPENSE_PURCHASE_TAX_INVOICE = 'expense-purchase-tax-invoice',
  EXPENSE_PURCHASE_CREDIT_NOTE = 'expense-purchase-credit-note',
  EXPENSE_PURCHASE_DEBIT_NOTE = 'expense-purchase-debit-note',
  EXPENSE_COMBINED_PAYMENT_NOTE = 'expense-combined-payment-note',
}

export enum IncomeDocumentStateTypes {
  DRAFT = 'draft',
  APPROVED = 'approved',
  AWAIT_APPROVAL = 'await-approval',
  AWAIT_ACCEPT = 'await-accept',
  AWAIT_DEDUCT = 'await-deduct',
  AWAIT_RECEIPT = 'await-receipt',
  AWAIT_TAX_INVOICE = 'await-tax-invoice',
  ACCEPTED = 'accepted',
  DEDUCTED = 'deducted',
  RECEIVE_RECEIPT = 'receive-receipt',
  RECEIVE_TAX_INVOICE = 'receive-tax-invoice',
  AUTO_GENERATED = 'auto-generated',
  COMPLETELY = 'completely',
  OVERDUE = 'overdue',
  OUTSTANDING = 'outstanding',
  ISSUED = 'issued',
  INVOICE = 'invoice',
  PAID = 'paid',
  EXPIRED = 'expired',
  VOIDED = 'voided',
  RECURRING = 'recurring',
  PARTIAL = 'partial',
}

export enum DiscountType {
  FIXED,
  PERCENT,
}

export enum ReferenceType {
  REFER,
  NOT_REFER,
}

export const CHANNEL_OPTIONS = [
  {label: 'ออฟไลน์', value: 'offline'},
  {label: 'ออนไลน์ Shopee', value: 'shopee'},
  {label: 'ออนไลน์ Lazada', value: 'lazada'},
  {label: 'ออนไลน์ Tiktok', value: 'tiktok'},
]

export const VAT_TYPE_OPTIONS = [
  {label: 'แยกภาษี', value: VAT_TYPE_EXCLUDED},
  {label: 'รวมภาษี', value: VAT_TYPE_INCLUDED},
  {label: 'ไม่มี', value: VAT_TYPE_NONE},
]

export const EXPENSE_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: EXPENSE_TYPE_DEPOSIT},
  {label: 'บันทึกซื้อสินค้า/ค่าใช้จ่าย', value: EXPENSE_TYPE_PURCHASE},
]

export const EXPENSE_COMBINED_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: EXPENSE_TYPE_DEPOSIT},
  {label: 'บันทึกซื้อสินค้า/ค่าใช้จ่าย', value: EXPENSE_TYPE_PURCHASE},
  {label: 'รับใบลดหนี้', value: EXPENSE_TYPE_PURCHASE_CREDIT_NOTE},
  {label: 'รับใบเพิ่มหนี้', value: EXPENSE_TYPE_PURCHASE_DEBIT_NOTE},
  {label: 'ทั้งหมด', value: EXPENSE_TYPE_ALL},
]

export const VAT_OPTIONS = [
  {label: 'ไม่มี', value: 99},
  {label: '0%', value: 0},
  {label: '7%', value: 7},
]

export const TAX_OPTIONS = [
  {label: 'ไม่มี', value: 0},
  {label: '.75%', value: 0.75},
  {label: '1%', value: 1},
  {label: '1.5%', value: 1.5},
  {label: '2%', value: 2},
  {label: '3%', value: 3},
  {label: '5%', value: 5},
  {label: '7%', value: 7},
  {label: '10%', value: 10},
  {label: 'กำหนดเอง', value: 99},
]

// Function to get product payment account options from API
export const getProductPaymentAccountOptions = async (): Promise<{label: string, value: string}[]> => {
  try {
    const response = await getAccounts()
    const accounts: Account[] = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : [])
    
    return accounts.map((account: Account) => ({
      label: `${account.code} - ${account.name}`,
      value: account.code
    }))
  } catch (error) {
    console.error('Error fetching accounts:', error)
    // Fallback to original static data if API fails
    return []
  }
}

// Keep the original constant for backward compatibility (deprecated)
export const PRODUCT_PAYMENT_ACCOUNT_OPTIONS = [
  {label: 'เงินรับล่วงหน้า - เงินมัดจำ', value: '212104'},
  {label: 'เงินจ่ายล่วงหน้า - เงินมัดจำ', value: '115104'},
]

export const PAYMENT_METHOD_OPTION = [
  {label: '+ เพิ่มช่องทาง', value: 'create'},
  {label: 'เช็ค', value: 'cheque', id: 'cheque'},
]

export const BANK_LIST_ONLY_OPTIONS = [
  {label: 'ธนาคารกสิกรไทย', value: 'kbank'},
  {label: 'ธนาคารกรุงเทพ', value: 'bbl'},
  {label: 'ธนาคารไทยพาณิชย์', value: 'scb'},
]

export const BANK_LIST_OPTIONS = [{label: 'เงินสด', value: 'cash'}, ...BANK_LIST_ONLY_OPTIONS]

export const DOCUMENT_TYPE_OPTION = [
  {label: 'ใบรับเงินมัดจำ', value: 'deposit'},
  {label: 'ใบแจ้งหนี้', value: 'invoice'},
  {label: 'ใบเสร็จรับเงิน', value: 'receipt'},
]

export const CREDIT_NOTE_REASON_OPTION = [
  {
    label: 'ลดราคาสินค้า',
    value: 'credit-note-reason-1',
    message: 'เนื่องจากผิดจากที่ตกลงกัน ชำรุดเสียหาย ไม่ครบ หรือคำนวณราคาผิด',
  },
  {
    label: 'ลดราคาค่าบริการ',
    value: 'credit-note-reason-2',
    message: 'เนื่องจากผิดจากที่ตกลงกัน ให้บริการไม่ครบ หรือคำนวณราคาผิด',
  },
  {
    label: 'ได้รับคืนสินค้า',
    value: 'credit-note-reason-3',
    message: 'เนื่องจากผิดจากชำรุดเสียหาย ไม่ครบ ไม่ตรงตามตัวอย่าง หรือไม่ตรงตามคำบรรยาย',
  },
  {
    label: 'จ่ายเงินชดเชย',
    value: 'credit-note-reason-4',
    message: 'ให้แก่ผู้ซื้อสินค้า หรือผู้รับบริการตามข้อผูกพัน/ข้อตกลงกัน',
  },
  {
    label: 'จ่ายเงินคืนเงินล่วงหน้า เงินมัดจำ เงินประกัน เงินจอง',
    value: 'credit-note-reason-5',
    message: 'ให้แก่ผู้ซื้อสินค้า หรือผู้รับบริการตามข้อผูกพัน/ข้อตกลงกัน',
  },
  {
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
    value: 'credit-note-reason-6',
    message: 'ระหว่างผู้ประกอบการ VAT ด้วยกัน',
  },
  {
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
    value: 'credit-note-reason-7',
    message: 'ระหว่างผู้ขายกับลูกค้า (เฉพาะภายในเวลาอันเหมาะสม)',
  },
  {label: 'บอกเลิกบริการ', value: 'credit-note-reason-8', message: 'เนื่องจากผิดจากที่ตกลงกัน'},
  {
    label: 'บอกเลิกบริการ',
    value: 'credit-note-reason-9',
    message: 'เนื่องจากไม่ได้มีการให้บริการตามสัญญา',
  },
  {label: 'อื่นๆ', value: 'etc'},
]

export const CREDIT_NOTE_ITEM_VOLUME_OPTION = [
  {label: 'ทุกรายการ', value: 1},
  {label: 'เฉพาะรายการ', value: 0},
]

export const CREDIT_NOTE_RETURN_ITEM_OPTION = [
  {label: 'รับสินค้าคืน', value: 1},
  {label: 'ไม่รับสินค้าคืน', value: 0},
]

export const DEBIT_NOTE_REASON_OPTION = [
  {
    label: 'เพิ่มราคาสินค้า',
    value: 'debit-note-reason-1',
    message: 'เพิ่มราคาสินค้า เนื่องจากสินค้าเกินกว่าจำนวนที่ตกลงกัน คำนวนราคาต่ำกว่าความเป็นจริง',
  },
  {
    label: 'เพิ่มราคาบริการ',
    value: 'debit-note-reason-2',
    message: 'เพิ่มราคาบริการ เนื่องจากให้บริการเกินกว่าที่กำหนด คำนวนราคาต่ำกว่าความเป็นจริง',
  },
  {label: 'อื่นๆ', value: 'etc'},
]

export const DEBIT_NOTE_ADDITIONAL_ITEM_OPTION = [
  {label: 'ส่งสินค้าเพิ่ม', value: 1},
  {label: 'ไม่ส่งสินค้าเพิ่ม', value: 0},
]

export const DEPARTMENT_OPTIONS = [
  {label: 'บริหาร', value: 1},
  {label: 'จัดการสนับสนุน', value: 2},
  {label: 'การขาย', value: 3},
  {label: 'การตลาด', value: 4},
  {label: 'บัญชี', value: 5},
  {label: 'การเงิน', value: 6},
  {label: 'บุคคล', value: 7},
  {label: 'ผลิต', value: 8},
  {label: 'จัดซื้อ', value: 9},
  {label: 'ทั่วไป', value: 10},
]

export const TAX_EXPENSE_OPTIONS = [
  {label: 'ค่าใช้จ่ายต้องห้าม', value: 1},
  {label: 'รายจ่ายที่หักภาษีได้เพิ่ม', value: 2},
  {label: 'รอพิจารณา', value: 3},
]

export const DEDUCT_DOCUMENT_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT},
  {label: 'ใบลดหนี้', value: IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE},
  {label: 'ใบเพิ่มหนี้', value: IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE},
]

export const DEDUCT_DOCUMENT_INCOME_TYPE_OPTIONS = [
  {label: 'ใบรับเงินมัดจำ', value: IncomeDocumentTypes.DEPOSIT},
  {label: 'ใบลดหนี้', value: IncomeDocumentTypes.CREDIT},
  {label: 'ใบเพิ่มหนี้', value: IncomeDocumentTypes.DEBIT},
]

export const PAYMENT_ADJUSTMENT_OPTIONS = [
  {label: 'หักเงินที่ต้องรับ', value: -1},
  {label: 'เพิ่มเงินที่ต้องรับ', value: 1},
]
export const EXPENSE_PAYMENT_ADJUSTMENT_OPTIONS = [
  {label: 'หักเงินที่ต้องจ่าย', value: -1},
  {label: 'เพิ่มเงินที่ต้องจ่าย', value: 1},
]

export const PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS = [
  {label: '590000 - ภาษีเงินได้', value: 590000},
  {label: '580201 - ค่าธรรมเนียมการกู้ยืม', value: 580201},
  {label: '580102 - ส่วนลดจากการขายเช็ค', value: 580102},
  {label: '580101 - ดอกเบี้ยจ่าย', value: 580101},
  {label: '540204 - เบี้ยปรับเงินเพิ่ม', value: 540204},
  {label: '540203 - เครดิตภาษีไม่ขอคืน', value: 540203},
  {label: '540202 - ภาษีซื้อขอคืนไม่ได้', value: 540202},
  {label: '540201 - ภาษีซื้อไม่ขอคืน', value: 540201},
  {label: '540190 - ขาดทุน(กำไร)จากการปัดเศษ', value: 540190},
  {label: '540105 - ขาดทุนจากอัตราแลกเปลี่ยน', value: 540105},
  {label: '540104 - ขาดทุนจากอัตราแลกเปลี่ยนที่ยังไม่รับรู้', value: 540104},
  {label: '540103 - ขาดทุนจากสินค้าสูญเสีย หรือสูญหาย', value: 540103},
  {label: '540102 - ขาดทุนจากการจำหน่ายสินทรัพย์', value: 540102},
  {label: '540101 - ค่าใช้จ่ายอื่น', value: 540101},
  {label: '530611 - รายจ่ายเพื่อการศึกษาหรือเพื่อการกีฬา', value: 530611},
  {label: '530610 - รายจ่ายเพื่อการกุศลอื่นๆ', value: 530610},
  {label: '530609 - รายจ่ายบริจาคให้แก่องค์กรกีฬา', value: 530609},
  {label: '530608 - รายจ่ายบริจาคให้แก่สถานศึกษา', value: 530608},
  {label: '530607 - รายจ่ายเพื่อโครงการฝึกอบรมอาชีพฯ', value: 530607},
  {label: '530606 - รายจ่ายในการตั้งศูนย์พัฒนาเด็กเล็กในสังกัด อปท', value: 530606},
  {label: '530605 - รายจ่ายเพื่อพัฒนาครู คณาจารย์ และบุคคลกรทางการศึกษา', value: 530605},
  {label: '530604 - รายจ่ายในการจัดให้คนพิการได้รับสิทธิประโยชน์', value: 530604},
  {label: '530603 - รายจ่ายในการจัดหาหนังสือหรือสื่ออิเล็กทรอนิกส์เพื่อสถานศึกษา', value: 530603},
  {label: '530602 - รายจ่ายเพื่อสนับสนุนการเรียนรู้และนันทนาการ', value: 530602},
  {label: '530601 - รายจ่ายเพื่อสนับสนุนการศึกษา', value: 530601},
  {label: '530509 - อากรแสตมป์', value: 530509},
  {label: '530508 - ภาษีป้าย', value: 530508},
  {label: '530507 - ภาษีบำรุงท้องที่', value: 530507},
  {label: '530506 - ภาษีที่ดินและสิ่งปลูกสร้าง', value: 530506},
  {label: '530505 - ภาษีธุรกิจเฉพาะ', value: 530505},
  {label: '530504 - ค่าธรรมเนียมอื่นๆ', value: 530504},
  {label: '530503 - ค่าธรรมเนียมในการให้คำแนะนำและปรึกษา', value: 530503},
  {label: '530502 - ค่าธรรมเนียมราชการ', value: 530502},
  {label: '530501 - ค่าธรรมเนียมธนาคาร', value: 530501},
  {label: '530408 - ค่าบริการอื่นๆ', value: 530408},
  {label: '530407 - ค่าจ้างทำของ', value: 530407},
  {label: '530406 - ค่าจ้างรับเหมา', value: 530406},
  {label: '530405 - ค่าจ้างรับทำงานให้', value: 530405},
  {label: '530404 - บริการวิชาชีพอื่นๆ', value: 530404},
  {label: '530403 - ค่าบริการด้านกฎหมาย', value: 530403},
  {label: '530402 - ค่าบริการสอบบัญชี', value: 530402},
  {label: '530401 - ค่าบริการบัญชี', value: 530401},
  {label: '530306 - ค่าบริการคลาวด์เซอร์วิซ', value: 530306},
  {label: '530305 - ค่าบริการโฮสติ้ง และเว็บไซต์', value: 530305},
  {label: '530304 - ค่าอินเทอร์เน็ต', value: 530304},
  {label: '530303 - ค่าโทรศัพท์สำนักงาน', value: 530303},
  {label: '530302 - ค่าประปา', value: 530302},
  {label: '530301 - ค่าไฟฟ้า', value: 530301},
  {label: '530212 - ค่าไปรษณีย์ และขนส่ง', value: 530212},
  {label: '530211 - ค่าซ่อมแซม', value: 530211},
  {label: '530210 - ค่ารักษาความสะอาด', value: 530210},
  {label: '530209 - ค่ารักษาความปลอดภัย', value: 530209},
  {label: '530208 - ค่าสมาชิกสมาคมฯ', value: 530208},
  {label: '530207 - ค่าหนังสือ วารสาร', value: 530207},
  {label: '530206 - ค่าเครื่องเขียน วัสดุ', value: 530206},
  {label: '530205 - ค่าบริการสำนักงานเสมือน', value: 530205},
  {label: '530204 - ค่าเช่าอุปกรณ์', value: 530204},
  {label: '530203 - ค่าเช่ายานพาหนะ', value: 530203},
  {label: '530202 - ค่าส่วนกลางสำนักงาน', value: 530202},
  {label: '530201 - ค่าเช่าสำนักงาน', value: 530201},
  {label: '530115 - ค่าจ้างเพื่อการวิจัยและพัฒนาเทคโนโลยี', value: 530115},
  {label: '530114 - ค่าใช้จ่ายในการจัดหาพนักงาน', value: 530114},
  {label: '530113 - เงินชดเชยการเลิกจ้าง', value: 530113},
  {label: '530112 - ค่าสวัสดิการอื่นๆ', value: 530112},
  {label: '530111 - ค่าประกันสุขภาพกลุ่ม', value: 530111},
  {label: '530110 - ค่าประกันชีวิตกลุ่ม', value: 530110},
  {label: '530109 - เงินช่วยเหลือยานพาหนะ', value: 530109},
  {label: '530108 - ค่าสวัสดิการอาหาร เครื่องดื่ม', value: 530108},
  {label: '530107 - ค่าอบรม สัมมนา', value: 530107},
  {label: '530106 - ค่ารักษาพยาบาล', value: 530106},
  {label: '530105 - เงินสมทบกองทุนสำรองเลี้ยงชีพ', value: 530105},
  {label: '530104 - เงินสมทบประกันสังคม และกองทุนทดแทน', value: 530104},
  {label: '530103 - ค่าตอบแทนกรรมการ', value: 530103},
  {label: '530102 - โบนัส', value: 530102},
  {label: '530101 - เงินเดือน ค่าจ้าง', value: 530101},
  {label: '520309 - หนี้สูญ', value: 520309},
  {label: '520308 - หนี้สงสัยจะสูญ', value: 520308},
  {label: '520307 - ค่ารับรอง', value: 520307},
  {label: '520306 - ค่าโทรศัพท์ฝ่ายขาย', value: 520306},
  {label: '520305 - ค่าเบี้ยเลี้ยงเดินทาง', value: 520305},
  {label: '520304 - ค่าที่พัก', value: 520304},
  {label: '520303 - ค่าน้ำมัน', value: 520303},
  {label: '520302 - ค่าเดินทางต่างประเทศ', value: 520302},
  {label: '520301 - ค่าเดินทางในประเทศ', value: 520301},
  {label: '520218 - ค่าโฆษณาอื่นๆ', value: 520218},
  {label: '520217 - ค่าจ้างนักแสดงสาธารณะ', value: 520217},
  {label: '520216 - ค่าจ้างงานบุคคลงานอิเวนต์', value: 520216},
  {label: '520215 - ค่าใช้จ่ายเกี่ยวกับบูท', value: 520215},
  {label: '520214 - ค่าสินค้าตัวอย่าง', value: 520214},
  {label: '520213 - ค่าส่งเสริมการขาย', value: 520213},
  {label: '520212 - รางวัลในการประกวดแข่งขัน ชิงโชค', value: 520212},
  {label: '520211 - ค่าจ้างที่ปรึกษาการตลาด', value: 520211},
  {label: '520210 - ค่าจ้างผลิตสื่อโฆษณา', value: 520210},
  {label: '520209 - ค่าจ้างทำ SEO', value: 520209},
  {label: '520208 - ค่าจ้างบริการเว็บไซต์', value: 520208},
  {label: '520207 - ค่าโฆษณาสื่อนอกบ้าน', value: 520207},
  {label: '520206 - ค่าโฆษณาสิ่งพิมพ์', value: 520206},
  {label: '520205 - ค่าโฆษณาโทรทัศน์', value: 520205},
  {label: '520204 - ค่าโฆษณาวิทยุ', value: 520204},
  {label: '520203 - ค่าโฆษณาออนไลน์อื่น', value: 520203},
  {label: '520202 - ค่าโฆษณา Facebook Ads', value: 520202},
  {label: '520201 - ค่าโฆษณา Google Adwords', value: 520201},
  {label: '520102 - โบนัสจากยอดขาย', value: 520102},
  {label: '520101 - ค่านายหน้า ส่วนแบ่งการขาย', value: 520101},
  {label: '510201 - ต้นทุนการก่อสร้าง', value: 510201},
  {label: '510110 - ค่าแลป/ฟันปลอม', value: 510110},
  {label: '510109 - ค่าใช้จ่ายอื่นๆในการซื้อสินค้า', value: 510109},
  {label: '510108 - ค่าอากรขาเข้า', value: 510108},
  {label: '510107 - ค่าขนส่งสินค้า', value: 510107},
  {label: '510106 - ค่าประกันภัยสินค้า', value: 510106},
  {label: '510105 - ค่าลิขสิทธิ์ กู๊ดวิลล์', value: 510105},
  {label: '510104 - ต้นทุนการให้บริการ', value: 510104},
  {label: '510103 - ต้นทุนขายสินค้า', value: 510103},
  {label: '510101 - ต้นทุนผลิตสินค้า', value: 510101},
  {label: '420109 - รายได้จากการบริการพื้นที่เช่า', value: 420109},
  {label: '420108 - รายได้อื่น', value: 420108},
  {label: '420107 - เงินรางวัล หรือ เงินสนับสนุน', value: 420107},
  {label: '420106 - เงินชดเชยค่าภาษีอากร', value: 420106},
  {label: '420105 - เงินปันผลหรือส่วนแบ่งกำไร', value: 420105},
  {label: '420104 - ดอกเบี้ยรับ', value: 420104},
  {label: '420103 - กำไรจากอัตราแลกเปลี่ยน', value: 420103},
  {label: '420102 - กำไรจากอัตราแลกเปลี่ยนที่ยังไม่รับรู้', value: 420102},
  {label: '420101 - กำไรจากการจำหน่ายสินทรัพย์', value: 420101},
  {label: '410401 - รายได้ค่าก่อสร้าง', value: 410401},
  {label: '410303 - ส่วนลดค่าบริการทางการแพทย์', value: 410303},
  {label: '410302 - ส่วนลดจ่าย', value: 410302},
  {label: '410301 - รับคืน', value: 410301},
  {label: '410206 - รายได้วัสดุพิเศษ', value: 410206},
  {label: '410205 - รายได้เวชภัณฑ์', value: 410205},
  {label: '410204 - รายได้ค่า X-ray', value: 410204},
  {label: '410203 - รายได้ค่าบริการทางการแพทย์', value: 410203},
  {label: '410202 - รายได้ค่ารักษาทางการแพทย์', value: 410202},
  {label: '410201 - รายได้จากการให้บริการ', value: 410201},
  {label: '410103 - รายได้ขายสินค้าหน้าร้าน', value: 410103},
  {label: '410102 - รายได้ขายสินค้า-ต่อเนื่องการรักษา', value: 410102},
  {label: '410101 - รายได้จากการขายสินค้า', value: 410101},
  {label: '344000 - องค์ประกอบอื่นของส่วนของผู้ถือหุ้น อื่นๆ', value: 344000},
  {label: '343000 - ผลกำไร (ขาดทุน) ที่ยังไม่เกิดขึ้นจริงอื่น', value: 343000},
  {label: '342000 - ผลกำไร (ขาดทุน) จากการวัดมูลค่าเงินลงทุนเผื่อขาย', value: 342000},
  {label: '341000 - ผลต่างของอัตราแลกเปลี่ยนจากการแปลงค่างบการเงิน', value: 341000},
  {label: '333000 - ผลสะสมจากการแก้ไขข้อผิดพลาดทางการบัญชี', value: 333000},
  {label: '332000 - ผลกระทบของการเปลี่ยนแปลงนโยบายการบัญชี', value: 332000},
  {label: '331000 - เงินปันผล', value: 331000},
  {label: '330000 - กำไร(ขาดทุน)สะสม', value: 330000},
  {label: '322000 - สำรองอื่น', value: 322000},
  {label: '321000 - สำรองตามกฎหมาย', value: 321000},
  {label: '314000 - ส่วนเกินมูลค่าหุ้นบุริมสิทธิ', value: 314000},
  {label: '313000 - หุ้นบุริมสิทธิ', value: 313000},
  {label: '312000 - ส่วนเกินมูลค่าหุ้นสามัญ', value: 312000},
  {label: '311000 - หุ้นสามัญ', value: 311000},
  {label: '223101 - หนี้สินไม่หมุนเวียนอื่น', value: 223101},
  {label: '222102 - ประมาณการหนี้สินระยะยาวอื่น', value: 222102},
  {label: '222101 - ประมาณการหนี้สินผลประโยชน์พนักงาน', value: 222101},
  {label: '221104 - หนี้สินตามสัญญาเช่าเงินทุน', value: 221104},
  {label: '221103 - เงินกู้ยืมระยะยาวจากบุคคลอื่น', value: 221103},
  {label: '221102 - เงินกู้ยืมระยะยาวจากบุคคลที่เกี่ยวข้องกัน', value: 221102},
  {label: '221101 - เงินกู้ยืมระยะยาวจากธนาคาร', value: 221101},
  {label: '216102 - หนี้สินหมุนเวียนอื่น', value: 216102},
  {label: '216101 - ดอกเบี้ยค้างจ่าย', value: 216101},
  {label: '215501 - ประกันสังคมค้างจ่าย', value: 215501},
  {label: '215401 - ภ.ธ. 40 ค้างจ่าย', value: 215401},
  {label: '215355 - เจ้าหนี้สรรพากร ภ.ง.ด. 53 รอชำระ', value: 215355},
  {label: '215354 - เจ้าหนี้สรรพากร ภ.ง.ด. 3 รอชำระ', value: 215354},
  {label: '215353 - เจ้าหนี้สรรพากร ภ.ง.ด. 2 รอชำระ', value: 215353},
  {label: '215352 - เจ้าหนี้สรรพากร ภ.ง.ด. 1 รอชำระ', value: 215352},
  {label: '215351 - เจ้าหนี้สรรพากร ภ.พ.30 รอชำระ', value: 215351},
  {label: '215302 - เจ้าหนี้สรรพากร', value: 215302},
  {label: '215301 - ภาษีเงินได้นิติบุคคลค้างจ่าย', value: 215301},
  {label: '215205 - ภ.ง.ด. 54 ค้างจ่าย', value: 215205},
  {label: '215204 - ภ.ง.ด. 53 ค้างจ่าย', value: 215204},
  {label: '215203 - ภ.ง.ด. 3 ค้างจ่าย', value: 215203},
  {label: '215202 - ภ.ง.ด. 2 ค้างจ่าย', value: 215202},
  {label: '215201 - ภ.ง.ด. 1 ค้างจ่าย', value: 215201},
  {label: '215103 - ภ.พ.36 ค้างจ่าย', value: 215103},
  {label: '215102 - ภาษีขายรอเรียกเก็บ', value: 215102},
  {label: '215101 - ภาษีขาย ภ.พ.30', value: 215101},
  {label: '214101 - ประมาณการหนี้สินระยะสั้น', value: 214101},
  {label: '213102 - ส่วนของหนี้สินตามสัญญาเช่าเงินทุนที่ถึงกำหนดชำระภายในหนึ่งปี', value: 213102},
  {label: '213101 - เงินกู้ยืมระยะยาวที่ถึงกำหนดชำระภายในหนึ่งปี', value: 213101},
  {label: '212307 - เจ้าหนี้เช่าซื้อ', value: 212307},
  {label: '212306 - เจ้าหนี้อื่น', value: 212306},
  {label: '212305 - ค่าใช้จ่ายค้างจ่ายอื่น', value: 212305},
  {label: '212304 - ค่าทำบัญชีค้างจ่าย', value: 212304},
  {label: '212303 - ค่าสอบบัญชีค้างจ่าย', value: 212303},
  {label: '212302 - กองทุนสำรองเลี้ยงชีพค้างจ่าย', value: 212302},
  {label: '212301 - เงินเดือนค้างจ่าย', value: 212301},
  {label: '212202 - เงินกู้ยืมระยะสั้นจากบุคคลอื่น', value: 212202},
  {label: '212201 - เงินกู้ยืมระยะสั้นจากบุคคลที่เกี่ยวข้องกัน', value: 212201},
  {label: '212107 - ค่าเช่าค้างจ่าย', value: 212107},
  {label: '212106 - ค่าแลปค้างจ่าย', value: 212106},
  {label: '212105 - เงินรับล่วงหน้า - เงินประกัน', value: 212105},
  {label: '212104 - เงินรับล่วงหน้า - เงินมัดจำ', value: 212104},
  {label: '212103 - รายได้รับล่วงหน้า', value: 212103},
  {label: '211301 - เงินกู้ยืมระยะสั้นธนาคารมีหลักประกัน', value: 211301},
  {label: '211201 - เงินกู้ยืมระยะสั้นธนาคารไม่มีหลักประกัน', value: 211201},
  {label: '126101 - สินทรัพย์ไม่หมุนเวียนอื่น', value: 126101},
  {label: '121101 - เงินลงทุนเผื่อขาย', value: 121101},
  {label: '115452 - ลูกหนี้สรรพากร ภ.พ.30 รอรับคืนจากการขอคืน', value: 115452},
  {label: '115451 - เครดิต ภ.พ.30 ที่ชำระเกินรอนำไปใช้', value: 115451},
  {label: '115405 - ลูกหนี้สรรพากร', value: 115405},
  {label: '115404 - ภาษีเงินได้ครึ่งปี', value: 115404},
  {label: '115403 - ภาษีถูกหัก ณ ที่จ่าย', value: 115403},
  {label: '115402 - ภาษีซื้อยังไม่ถึงกำหนด', value: 115402},
  {label: '115401 - ภาษีซื้อ', value: 115401},
  {label: '115302 - รายได้ค้างรับอื่น', value: 115302},
  {label: '115301 - ดอกเบี้ยค้างรับ', value: 115301},
  {label: '115201 - เงินทดรองจ่ายพนักงาน', value: 115201},
  {label: '115105 - เงินจ่ายล่วงหน้า - เงินประกัน', value: 115105},
  {label: '115104 - เงินจ่ายล่วงหน้า - เงินมัดจำ', value: 115104},
  {label: '115103 - ค่าใช้จ่ายจ่ายล่วงหน้า - อื่น', value: 115103},
  {label: '115102 - ค่าใช้จ่ายจ่ายล่วงหน้า - ค่าเช่า', value: 115102},
  {label: '115101 - ค่าใช้จ่ายจ่ายล่วงหน้า - ค่าสินค้า', value: 115101},
  {label: '113301 - ลูกหนี้อื่น', value: 113301},
  {label: '113203 - เงินรับล่วงหน้าที่พนักงาน', value: 113203},
  {label: '113202 - เงินให้กู้ยืม-บุคคลอื่น', value: 113202},
  {label: '113201 - เงินให้กู้ยืม-บุคคลที่เกี่ยวข้องกัน', value: 113201},
  {label: '113103 - ค่าเผื่อหนี้สงสัยจะสูญ', value: 113103},
  {label: '999999 - บัญชีพัก', value: 999999},
]

export enum DEBT_REDUCTION_REASON {
  PRODUCT_PRICE_REDUCTION = 'product_price_reduction',
  SERVICE_PRICE_REDUCTION = 'service_price_reduction',
  PRODUCT_RETURN = 'product_return',
  COMPENSATION_PAYMENT = 'compensation_payment',
  ADVANCE_REFUND = 'advance_refund',
  BUSINESS_EXCHANGE = 'business_exchange',
  CUSTOMER_EXCHANGE = 'customer_exchange',
  SERVICE_CANCELLATION_AGREEMENT = 'service_cancellation_agreement',
  SERVICE_CANCELLATION_BREACH = 'service_cancellation_breach',
  OTHER = 'other',
}

export enum DEBT_ADDITION_REASON {
  PRODUCT_PRICE_INCREASE = 'product_price_increase',
  SERVICE_PRICE_INCREASE = 'service_price_increase',
  OTHER = 'other',
}

export enum DEBT_REDUCTION_SCOPE {
  ALL_ITEMS = 'all_items',
  SPECIFIC_ITEMS = 'specific_items',
}

export enum PRODUCT_RETURN_OPTION {
  ALL_RETURN = 'all_return',
  NO_RETURN = 'no_return',
}

export enum PRODUCT_RECEIVE_OPTION {
  RECEIVE_MORE = 'receive_more',
  NOT_RECEIVE_MORE = 'not_receive_more',
}
